module.exports = __webpack_public_path__ + "img/search-icon-dark-blue.870fb1c8.svg";